var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"SignUpFooter text-center"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.footerTitle))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iconDiv d-inline-block mr-2"},[_c('div',{staticClass:"iconDiv__icon"},[_c('span',[_vm._v("C")])])])
}]

export { render, staticRenderFns }